<template>
  <modal :title="title" class="modalPopupDialog" :max-width="maxWidth" @close="closeDialog">
    <div>
      <div id="optionSelection">
        <input
          v-if="showOptionsSearchInput"
          ref="searchInput"
          v-model="searchQuery"
          type="text"
          placeholder="Zoeken..."
          class="search-input"
        />

        <div class="option-select-box custom-scrollbar">
          <div
            v-for="item in filteredAvailableItems"
            :key="item.Id"
            class="option-item"
            :class="{
              'option-selected': selectedItem?.Id === item.Id,
              'option-disabled': item.Disabled,
            }"
            @click="selectAvailableOption(item)"
            @dblclick="!item.Disabled && confirmSelection()"
          >
            <div v-if="showId" class="option-id">{{ item.ShortId }}</div>
            <div class="option-name">{{ item.Name }}</div>
            <div v-if="showPrices" class="option-price">
              {{ priceIncl(item) }}
            </div>
            <i
              v-if="item.Disabled && item.DisabledReason"
              class="fa-solid fa-circle-info info-icon"
              :title="item.DisabledReason"
            ></i>
          </div>
        </div>
      </div>
      <br /><br />
      <div style="position: relative">
        <app-button
          button-class="primary"
          style="position: absolute; right: 0; bottom: 0"
          button-type="button"
          data-qa="single-feature-change-confirm-button"
          @click="confirmSelection"
        >
          {{ i18n.t('/common/confirm') }}
        </app-button>
      </div>
    </div>
  </modal>
</template>

<script>
import Modal from '@/components/generic/presentational/molecules/modal/Modal.vue'
import AppButton from '@/components/generic/presentational/atoms/appButton/AppButton.vue'
export default {
  components: {
    Modal,
    AppButton,
  },
  props: {
    showDialog: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '',
    },
    items: {
      type: Array,
      required: true,
    },
    maxWidth: {
      type: String,
      default: '',
    },
    showOptionsSearchInput: {
      type: Boolean,
      default: false,
    },
    showId: {
      type: Boolean,
      default: true,
    },
    showPrices: {
      type: Boolean,
      default: true,
    },
  },
  emits: ['close', 'confirm'],
  data() {
    return {
      i18n: window.VUE_CLI_EXPORTS.plugins.i18n,
      selectedItem: null,
      searchQuery: '',
    }
  },
  computed: {
    maxIdLength() {
      return Math.max(...this.items.map((item) => String(item.Id).length))
    },
    filteredAvailableItems() {
      if (!this.searchQuery) {
        return this.items
      }
      const searchLowerCase = this.searchQuery.toLowerCase()
      return this.items.filter((item) => {
        const nameLowerCase = item.Name ? item.Name.toLowerCase() : '' // handle null values
        const itemId = item.Id.toLowerCase()

        return nameLowerCase.includes(searchLowerCase) || itemId.includes(searchLowerCase)
      })
    },
  },
  methods: {
    priceIncl(item) {
      if (item.Price) {
        return Number.parseFloat(item.Price.Incl) !== 0
          ? this.i18n.n(item.Price.Incl, 'currency')
          : 'Geen meerprijs'
      }
      return 'prijs onbekend'
    },
    selectAvailableOption(item) {
      if (item.Disabled) {
        return
      }
      this.selectedItem = item
    },
    closeDialog() {
      this.$emit('close')
    },
    confirmSelection() {
      if (this.selectedItem) {
        this.$emit('confirm', this.selectedItem)
      }
      this.closeDialog()
    },
  },
}
</script>

<!-- Styles will be similar as the Modal, and you can adjust as needed -->

<style lang="scss" scoped>
.modalPopupDialog {
  z-index: 999;
}

#optionSelection {
  padding: 2px;
  height: 100%;
}

.search-input {
  width: 100%;
  height: 38px;
  margin-bottom: 10px;
}

.search-input::placeholder {
  font-size: 0.85em;
  color: #999;
}

.option-select-box {
  width: 100% !important;
  height: 300px;
  overflow-y: scroll;
}

.option-item {
  display: flex;
  justify-content: start;
  align-items: start;
  cursor: pointer;
  border-bottom: 1px solid #eee;

  .option-id {
    padding-left: 5px;
    width: 70px;
    padding-right: 10px;
  }
  .option-name {
    padding-right: 16px;
  }
  .option-price {
    white-space: nowrap;
    margin-left: auto;
    text-align: right;
    margin-right: 15px;
  }
  .info-icon {
    margin-right: 5px;
    align-self: center;
  }
}

.option-disabled {
  color: #999;
  cursor: not-allowed;
}

.option-disabled:hover:not(.option-selected) {
  background-color: transparent;
}

.option-item:hover:not(.option-selected) {
  background-color: #f9f9f9;
}

.option-selected {
  color: white;
  background-color: #0c3da6;
}

.custom-scrollbar {
  width: 100px;
  border: #000000 inset thin;
}

.custom-scrollbar::-webkit-scrollbar {
  width: 20px;
}

.custom-scrollbar::-webkit-scrollbar-track {
  background-color: #ebebeb;
}

.custom-scrollbar::-webkit-scrollbar-thumb {
  background: #6d6d6d;
}
</style>
